import { useState } from "@wordpress/element";
import { useTranslation } from "react-i18next";
import { WarningSchema } from "@/schemas/warning-data-schema";

import iconArrow from "@/img/arrow-details-icon.svg";
import ContentEventsDetails from "../content-events-details/ContentEventsDetails";
import TimeLinesContent from "../timelines-content/TimeLinesContent";

import "./style.scss";

type MapDetailsProps = {
	isOpen: boolean;
	toggleOpen: () => void;
	selectedPolygonId?: string;
	warningData: WarningSchema[];
	isLoading: boolean;
	error: string | null;
	filter?: string;
};

export const MapDetails = ({
	isOpen,
	selectedPolygonId,
	warningData,
	isLoading,
	error,
	filter,
	toggleOpen,
}: MapDetailsProps) => {
	const { t } = useTranslation();
	const [entitySelected, setEntitySelected] = useState<"events" | "timeline">(
		"events",
	);

	if (isLoading) {
		return <p>loader</p>;
	}
	if (error) {
		return <p>une erreur est survenue</p>;
	}

	return (
		<div className="map-details">
			<div className={`${isOpen ? "details-div-open" : "details-div-close"}`}>
				<button className="open-details-button" onClick={() => toggleOpen()}>
					<img src={iconArrow} alt="open details" />
					{t("warningDetails")}
				</button>

				{isOpen && (
					<div className="select-entity-div">
						<button
							className={`${entitySelected === "events" && "active-entity"}`}
							onClick={() => setEntitySelected("events")}
						>
							{t("events")}
						</button>
						<button
							className={`${entitySelected === "timeline" && "active-entity"}`}
							onClick={() => setEntitySelected("timeline")}
						>
							{t("timeline")}
						</button>
					</div>
				)}
			</div>

			{isOpen && (
				<div className="details-content">
					{entitySelected === "events" ? (
						<ContentEventsDetails
							warningData={warningData}
							selectedPolygonId={selectedPolygonId}
							filter={filter}
						/>
					) : (
						<TimeLinesContent
							warningData={warningData}
							selectedPolygonId={selectedPolygonId}
						/>
					)}
				</div>
			)}
		</div>
	);
};

export default MapDetails;
